import React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@material-ui/core';

const ImplementationPhasesGrid = ({ sectionConfig = {}, layoutContext = {} }) => {
    const { getAnimationProps } = layoutContext;
    const items = sectionConfig.items || [];

    if (!items.length) {
        return null;
    }

    const applyAnimation = (animationConfig, index = 0) => (
        typeof getAnimationProps === 'function' ? getAnimationProps(animationConfig, index) : {}
    );
    const sectionAnimation = applyAnimation(sectionConfig.animation?.section);
    const titleAnimation = applyAnimation(sectionConfig.animation?.title);

    return (
        <Box
            id="implementation-section"
            className={sectionAnimation.className}
            data-anim={sectionAnimation.dataAnim}
            data-delay={sectionAnimation.dataDelay}
            data-trigger-once={sectionAnimation.dataTriggerOnce}
            style={{ ...(sectionConfig.styles || {}), ...(sectionAnimation.style || {}) }}
        >
            <Container
                maxWidth={sectionConfig.container?.maxWidth || 'lg'}
                style={{ textAlign: 'center', ...(sectionConfig.container?.styles || {}) }}
            >
                <Box
                    className={titleAnimation.className}
                    data-anim={titleAnimation.dataAnim}
                    data-delay={titleAnimation.dataDelay}
                    data-trigger-once={titleAnimation.dataTriggerOnce}
                    style={{ ...(titleAnimation.style || {}) }}
                >
                    {sectionConfig.label && (
                        <Typography variant={sectionConfig.typography?.label?.variant || 'overline'} style={sectionConfig.labelStyles || {}}>
                            {sectionConfig.label}
                        </Typography>
                    )}
                    <Typography variant={sectionConfig.typography?.title?.variant || 'h3'} style={sectionConfig.titleStyles || {}}>
                        {sectionConfig.title}
                    </Typography>
                    {sectionConfig.subtitle && (
                        <Typography variant={sectionConfig.typography?.subtitle?.variant || 'body1'} style={sectionConfig.subtitleStyles || {}}>
                            {sectionConfig.subtitle}
                        </Typography>
                    )}
                </Box>
                <Grid container spacing={sectionConfig.grid?.spacing || 4}>
                    {items.map((phase, index) => {
                        const cardAnimation = applyAnimation(sectionConfig.animation?.items, index);
                        return (
                            <Grid
                            item
                            xs={sectionConfig.gridItem?.xs || 12}
                            sm={sectionConfig.gridItem?.sm || 6}
                            md={sectionConfig.gridItem?.md || 3}
                            key={`implementation-${index}`}
                        >
                            <Card
                                className={cardAnimation.className}
                                data-anim={cardAnimation.dataAnim}
                                data-delay={cardAnimation.dataDelay}
                                data-trigger-once={cardAnimation.dataTriggerOnce}
                                style={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    ...(sectionConfig.cardStyles || {}),
                                    ...(cardAnimation.style || {})
                                }}
                            >
                                <CardContent
                                    style={{
                                        flexGrow: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        ...(sectionConfig.cardContentStyles || {})
                                    }}
                                >
                                    <Box style={sectionConfig.phaseBadgeStyles || {}}>
                                        {phase.number || index + 1}
                                    </Box>
                                    <Typography variant={sectionConfig.typography?.cardTitle?.variant || 'h6'} style={sectionConfig.cardTitleStyles || {}}>
                                        {phase.title}
                                    </Typography>
                                    <Typography variant={sectionConfig.typography?.cardDescription?.variant || 'body2'} style={sectionConfig.cardDescriptionStyles || {}}>
                                        {phase.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default ImplementationPhasesGrid;
